import React from 'react';
import {
  HeroSection,
  CategorySection,
  AboutSection,
  LocationSection,
  FooterSection,
} from './sections';

function Home() {
  return (
    <main className="min-h-screen">
      <HeroSection />
      <CategorySection />
      <AboutSection />
      <LocationSection />
      <FooterSection />
    </main>
  );
}

export default Home;
